// extracted by mini-css-extract-plugin
export var CardTitle = "TicketThreeUpSection-module--CardTitle--06e03";
export var CardsContainer = "TicketThreeUpSection-module--CardsContainer--f2460";
export var cardContentWrapper = "TicketThreeUpSection-module--cardContentWrapper--2fdf2";
export var cardInfo = "TicketThreeUpSection-module--cardInfo--5e5b8";
export var freeCta = "TicketThreeUpSection-module--free-cta--92caf";
export var heading = "TicketThreeUpSection-module--heading--ea064";
export var lastCardDesign = "TicketThreeUpSection-module--lastCardDesign--60669";
export var linkContainer = "TicketThreeUpSection-module--linkContainer--a06ac";
export var mainContainer = "TicketThreeUpSection-module--mainContainer--006f6";
export var middleCardDesign = "TicketThreeUpSection-module--middleCardDesign--c1d68";
export var mostPopular = "TicketThreeUpSection-module--mostPopular--ea63b";
export var mostPopularCardDesign = "TicketThreeUpSection-module--mostPopularCardDesign--fbf78";
export var pricing = "TicketThreeUpSection-module--pricing--d5af0";
export var purchaseButton = "TicketThreeUpSection-module--purchaseButton--9e580";
export var singleCard = "TicketThreeUpSection-module--singleCard--2ea22";